"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogCertificazioneAnagrafeCedacriDtoToJSON = exports.LogCertificazioneAnagrafeCedacriDtoFromJSONTyped = exports.LogCertificazioneAnagrafeCedacriDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function LogCertificazioneAnagrafeCedacriDtoFromJSON(json) {
    return LogCertificazioneAnagrafeCedacriDtoFromJSONTyped(json, false);
}
exports.LogCertificazioneAnagrafeCedacriDtoFromJSON = LogCertificazioneAnagrafeCedacriDtoFromJSON;
function LogCertificazioneAnagrafeCedacriDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'idCertificazione': !runtime_1.exists(json, 'idCertificazione') ? undefined : json['idCertificazione'],
        'logRispostaAnagrafeCedacri': !runtime_1.exists(json, 'logRispostaAnagrafeCedacri') ? undefined : json['logRispostaAnagrafeCedacri'],
        'logAnagrafeCedacri': !runtime_1.exists(json, 'logAnagrafeCedacri') ? undefined : json['logAnagrafeCedacri'],
        'containsErrors': !runtime_1.exists(json, 'containsErrors') ? undefined : json['containsErrors'],
        'dataInserimento': !runtime_1.exists(json, 'dataInserimento') ? undefined : (new Date(json['dataInserimento'])),
    };
}
exports.LogCertificazioneAnagrafeCedacriDtoFromJSONTyped = LogCertificazioneAnagrafeCedacriDtoFromJSONTyped;
function LogCertificazioneAnagrafeCedacriDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'idCertificazione': value.idCertificazione,
        'logRispostaAnagrafeCedacri': value.logRispostaAnagrafeCedacri,
        'logAnagrafeCedacri': value.logAnagrafeCedacri,
        'containsErrors': value.containsErrors,
        'dataInserimento': value.dataInserimento === undefined ? undefined : (value.dataInserimento.toISOString()),
    };
}
exports.LogCertificazioneAnagrafeCedacriDtoToJSON = LogCertificazioneAnagrafeCedacriDtoToJSON;
